import { GroupedStories } from "../../proto/StoryGetStories_pb";
import { StoryUserAddNewResponse } from "../../proto/StoryUserAddNew_pb";
import { StoryAddViewResponse } from "../../proto/StoryAddView_pb";
import { RegisteredUser, Story } from "../../proto/Global_pb";
import { GroupedViews } from "../../proto/StoryGetOwnStoryViews_pb";

export const SET_STORIES = "SET_STORIES";
export const DELETE_STORY = "DELETE_STORY";
export const UPDATE_STORIES = "UPDATE_STORIES";
export const UPDATE_SEEN_STORY = "UPDATE_SEEN_STORY";
export const ADD_STORY_VIEW = "ADD_STORY_VIEW";
export const UPDATE_STORY_VIEW = "UPDATE_STORY_VIEW";

export type StoriesStateType = {
  stories: StoriesType;
  storyList: storiesListType;
  storyViewedList: StoryViewedListType;
  unreadCount: number;
};
export type StoryIds = Array<GroupedStories.AsObject["originatorId"]>;
export type UpdateStoryType = StoryUserAddNewResponse.AsObject["storyList"];
export type storiesListType = Array<GroupedStories.AsObject["originatorId"]>;
export type StoriesType = {
  [originatorId in GroupedStories.AsObject["originatorId"]]: GroupedStories.AsObject;
};
export type StoryViewedListType = {
  [storyId in GroupedViews.AsObject["storyId"]]: GroupedViews.AsObject;
};

export type SetStoriesType = {
  type: typeof SET_STORIES;
  payload: Array<GroupedStories.AsObject>;
};

export type UpdateStoriesType = {
  type: typeof UPDATE_STORIES;
  payload: {
    originatorId: GroupedStories.AsObject["originatorId"];
    story: UpdateStoryType;
  };
};

export type UpdateSeenStoryType = {
  type: typeof UPDATE_SEEN_STORY;
  payload: StoryAddViewResponse.AsObject;
};

export type AddStoryViewType = {
  type: typeof ADD_STORY_VIEW;
  payload: Array<GroupedViews.AsObject>;
};

export type UpdateStoryViewType = {
  type: typeof UPDATE_STORY_VIEW;
  payload: Story.AsObject["id"];
};

export type DeleteStoryType = {
  type: typeof DELETE_STORY;
  payload: {
    userId: RegisteredUser.AsObject["id"];
    storyId: Story.AsObject["id"];
  };
};

export type StoriesActionTypes = SetStoriesType | UpdateStoriesType | UpdateSeenStoryType | DeleteStoryType | AddStoryViewType | UpdateStoryViewType;
